import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { extendObservable } from 'mobx'
import * as R from 'ramda'
import { getPrintPreview } from './utils'
import Switch from './formElements/Switch'
import '../../assets/scss/textInput.scss'

@observer
export default class TextInput extends Component {

	constructor(props){
		super(props)
		this.handleChange = this.handleChange.bind(this)
		this.onKeyPress = this.onKeyPress.bind(this)
		this.getWordCount = this.getWordCount.bind(this)

        const { question } = props

        if (question.settings.frontend.switch) {
            this.switchValue = question.settings.frontend.switch[0]
        } else {
            this.switchValue = undefined
        }
	}

	getWordCount(str){
		return str.split(' ').length
	}

	handleChange(e) {
		const { question, store, formId } = this.props
		console.log(e.target.type)
		if(	question.settings.frontend.hasOwnProperty("charLimit")
			&& e.target.value.length > question.settings.frontend.charLimit){
			return
		}
		if(	question.settings.frontend.hasOwnProperty("wordLimit")
			&& question.settings.frontend.wordLimit > 0
			&& this.getWordCount(e.target.value) > question.settings.frontend.wordLimit)
			{
			return
		}
		store.addFormResponse(question, {
            value: e.target.value,
            switch: this.switchValue,
            formId,
        })
	}

    changeSwitch = (e) => {
        const { question, store } = this.props
        const { form_data, langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const questionId = question.id
        const { checked } = e.target
        const switchValue = checked
            ? question.settings.frontend.switch[1]
            : question.settings.frontend.switch[0]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        this.switchValue = localeLabel

        if (form_data.has(questionId)) {
            const { data } = form_data.get(questionId)
            data.switch = localeLabel
            store.addFormResponse(question, data)
        }
    }

    getSwitchLabel = (target) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const index = target === 'left'
            ? 0
            : 1

        const switchValue = question.settings.frontend.switch[index]

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        return localeLabel
    }

	onKeyPress(event) {
	    if (event.which === 13 /* Enter */) {
	      event.preventDefault();
	    }
    }

    getPrePostFixLabel = (target) => {
        const { question, store } = this.props
        const { langcode } = store
        const { defaultLocale } = store.data.metadata
        const { initialLocale } = question

        const switchValue = question.settings.frontend[target] || {}

        let localeLabel = ''
        if (switchValue[langcode]) {
            localeLabel = switchValue[langcode].text
        } else if (switchValue[defaultLocale]) {
            localeLabel = switchValue[defaultLocale].text
        } else if (switchValue[initialLocale]) {
            localeLabel = switchValue[initialLocale].text
        }

        return localeLabel
    }
    
    preFix = () => {
        const { question, store } = this.props
        let elem = null

        if (!R.isEmpty(question.settings.frontend.prefix)) {
            elem = <div style={{ marginRight: '10px' }}>{store.prePostFix(question, 'prefix')}</div>
        }

        return elem
    }

    postFix = () => {
        const { question, store } = this.props
        let elem = null

        if (!R.isEmpty(question.settings.frontend.postfix)) {
            elem = <div style={{ marginLeft: '10px' }}>{store.prePostFix(question, 'postfix')}</div>
        }

        return elem
    }

	render() {
		const {question, store, validationMsg} = this.props
		const {form_data} = store
		const questionType = question.questionTypeCode
		const questionId = question.id
        const data = form_data.has(questionId) ? form_data.get(questionId).data : {}
		const value = data.value || ""
        if(questionType === "TX"){
            return (
                <div className={`TX ${question.settings.frontend.switch ? 'switch' : ''}`}>
                    {getPrintPreview(question, store)}
    				{this.preFix()}
                    <input id={questionId}
    					type="text"
    					name={questionId}
    					onChange={this.handleChange.bind(this)}
    					onBlur={this.handleChange.bind(this)}
						onKeyPress={this.onKeyPress.bind(this)}
    					value={value}
    				/>
                    {validationMsg}
                    {this.postFix()}
                    {question.settings.frontend.switch && (
                        <Switch
                            left={this.getSwitchLabel('left')}
                            right={this.getSwitchLabel('right')}
                            onChange={this.changeSwitch}
                            value={data.switch}
                        />
                    )}
    			</div>
    		)
        } else {
            return (
                <div>
                    {getPrintPreview(question, store)}
    				<textarea className='radius' id={questionId}
    					name={questionId}
    					onChange={this.handleChange.bind(this)}
    					onBlur={this.handleChange.bind(this)}
    					value={value}
    				/>
    			</div>
    		)
        }
    }
}
